<div class="from-gray-50 to-gray-100  flex flex-col  page mt-3">
  <div class="row" style="margin-top: 0px;">
    <div class="col-8 text-header" style="position: relative;">

      <div style="width: 39.97px;height: 39.97px;flex-shrink: 0;position: absolute;right: 30px;top: 0px;"
        (click)="retourToHomeClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
          <foreignObject x="-30" y="-30" width="99.9697" height="99.9697">
            <div xmlns="http://www.w3.org/1999/xhtml"
              style="backdrop-filter:blur(15px);clip-path:url(#bgblur_0_216_459_clip_path);height:100%;width:100%">
            </div>
          </foreignObject>
          <circle data-figma-bg-blur-radius="30" cx="19.9849" cy="19.9849" r="19.9849" fill="#F9F9F9"
            fill-opacity="0.4" />
          <g filter="url(#filter1_d_216_459)">
            <circle cx="19.9844" cy="19.9844" r="15.2266" fill="#F9F9F9" />
          </g>
          <defs>
            <clipPath id="bgblur_0_216_459_clip_path" transform="translate(30 30)">
              <circle cx="19.9849" cy="19.9849" r="19.9849" />
            </clipPath>
            <filter id="filter1_d_216_459" x="0.951166" y="1.90283" width="38.0664" height="38.0664"
              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha" />
              <feOffset dy="0.951662" />
              <feGaussianBlur stdDeviation="1.90332" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_216_459" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_216_459" result="shape" />
            </filter>
          </defs>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none"
          style="position: absolute;top:22%;left:20%">
          <path
            d="M15.5172 6.07959L11.451 10.1448L7.38572 6.07959L6.03064 7.43467L10.0959 11.4999L6.03064 15.5652L7.38572 16.9203L11.451 12.855L15.5172 16.9203L16.8723 15.5652L12.807 11.4999L16.8723 7.43467L15.5172 6.07959Z"
            fill="#3FCC9D" />
        </svg>

      </div>
    </div>
  </div>

  <!-- Main Container -->
  <div class="flex-1 overflow-y-auto pb-32 content">
    <div class="mx-auto list-drivers" style="padding-top: 41px;" >
      <!-- Trip Summary -->
      <div class="bg-white rounded-2xl shadow-lg mb-4">
        <div class="p-4">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <div class="flex items-center gap-2 mb-1">
                <mat-icon class="text-primary text-xl">location_on</mat-icon>
                <span class="text-xll text-gray-600">{{ pickup || ('LOCATION_PICKER.PICKUP_PLACEHOLDER' | translate) }}</span>
              </div>
              <div class="flex items-center gap-2">
                <mat-icon class="text-red-500 text-xl">location_on</mat-icon>
                <span class="text-xll text-gray-600">{{ destination || ('LOCATION_PICKER.DESTINATION_PLACEHOLDER' | translate) }}</span>
              </div>
            </div>
            <div class="text-right">
              <p class="text-xm text-gray-500 flex items-center justify-end gap-1">
                <mat-icon class="text-xl">people</mat-icon>
                {{ passengers }}
              </p>
              <p class="text-xm text-gray-500 flex items-center justify-end gap-1">
                <mat-icon class="text-xl">work</mat-icon>
                {{ luggage }}
              </p>
            </div>
          </div>
        </div>

        <!-- Progress Bar - Only show when searching -->
        <div *ngIf="isSearching" class="relative h-1 bg-gray-100">
          <div
            class="absolute left-0 top-0 h-full bg-gradient-to-r from-yellow-400 to-amber-500 transition-all duration-1000 ease-linear"
            [style.width.%]="getProgressWidth()"></div>
        </div>
      </div>
      @if (!isSearchCancelled() && errorMessage=="" ) {

      <!-- Search Status - Compact info -->
      <div *ngIf="isSearching || isSearchStarted()" class="flex items-center justify-between mb-4 px-2">
        <div class="flex items-center gap-2">
          <mat-icon class="text-yellow-600 animate-spin text-sm">autorenew</mat-icon>
          <div>
            <span class="text-sm text-gray-600">
              {{ visibleDriversCount }}<span *ngIf="visibleDriversCount > 1"></span> {{ visibleDriversCount > 1 ? ('DRIVERS.DRIVERS_FOUND_PLURAL' | translate) : ('DRIVERS.DRIVERS_FOUND' | translate) }}
            </span>
            <!-- <div class="text-xs text-gray-500">{{ 'SEARCH.REMAINING' | translate: {count: getRemainingRetries()} }}</div> -->
          </div>
        </div>
        <span class="text-sm text-yellow-600 font-semibold">{{ searchTimeRemaining | formatTime }}</span>
      </div>

      
      <!-- Total Drivers Found -->
      <div *ngIf="(!isSearching && visibleDriversCount > 0) "
        class="bg-emerald-50 border-2 border-emerald-200 rounded-2xl p-3 mb-4">
          <p class="text-emerald-700 text-center text-xl">✅ <strong>{{ visibleDriversCount }} {{ 'DRIVERS.DRIVERS_AVAILABLE' | translate }}</strong> {{ 'DRIVERS.FOR_YOUR_TRIP' | translate }}</p>        
      </div>

      <!-- No Drivers Found -->
      <div *ngIf="!isSearching && listDriversAccepted.length === 0 && visibleDriversCount === 0"
        class="bg-red-50 border-2 border-red-200 rounded-2xl p-3 mb-4">
          <p class="text-red-600 text-center text-lg">❌ <strong>{{ 'DRIVERS.NO_DRIVERS' | translate }}</strong></p>        
      </div>

      <!-- Available Drivers List -->
      <div class="space-y-3 ">
        <div *ngIf="listDriversAccepted.length === 0" class="bg-white rounded-2xl shadow-lg p-8 text-center"
          style="margin-bottom: 10px;">
          <div class="mb-4">
          <div *ngIf="isSearching" class="w-20 h-20 bg-yellow-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-loader-circle text-yellow-500 animate-spin" aria-hidden="true">
              <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
            </svg>
          </div>
          <div *ngIf="!isSearching" class="w-20 h-20 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check-circle text-emerald-500" aria-hidden="true">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
            <h3 class="text-gray-800 font-semibold mb-2 text-lg">
              {{ isSearching ? ('DRIVERS.SEARCHING_IN_PROGRESS' | translate) : ('DRIVERS.NO_DRIVERS_AVAILABLE' | translate) }}
            </h3>
            <p class="text-gray-500 text-lg mb-4">
              {{ isSearching
              ? ('DRIVERS.SEARCHING_DESCRIPTION' | translate)
              : ('DRIVERS.NO_DRIVERS_OCCUPIED' | translate)
              }}
            </p>
            <div class="bg-emerald-50 border-2 border-emerald-200 rounded-xl p-4  mb-4" *ngIf="!isSearching">
              <p class="text-emerald-70 text-base ">
                {{ 'DRIVERS.TIP_MESSAGE' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="!isSearching" class="bg-white rounded-2xl shadow-lg p-0 text-center"
          style="margin-bottom: 10px;">
          <div class="mb-0">


            <!-- <div *ngIf="showCustomPriceInput" class="mt-6 bg-primary-50 border-2 border-primary-100 rounded-xl p-4">
              <label class="block text-sm font-semibold text-gray-700 mb-3">
                {{ 'DRIVERS.CUSTOM_PRICE_LABEL' | translate }}
              </label>
              <div class="flex gap-2 mb-4">
                <input
                  type="number"
                  [(ngModel)]="customPriceAmount"
                  [placeholder]="'Ex: 50' | translate"
                  [min]="minAmount"
                  class="flex-1 px-4 py-3 border-2 border-primary-100 rounded-xl focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
                />
              </div>
              <p class="text-xs text-gray-600 mb-4">
                {{ 'DRIVERS.CUSTOM_PRICE_MIN' | translate: {minAmount: minAmount} }} | {{ 'DRIVERS.CUSTOM_PRICE_CURRENT' | translate }} {{ customPriceAmount ?? 0 }} DH
              </p>
              <div class="flex gap-2">
                <button
                  (click)="closeCustomPriceInput()"
                  class="flex-1 py-2 rounded-xl border-2 border-gray-200 bg-white text-gray-600 hover:bg-gray-50 transition-all active:scale-95"
                >
                  {{ 'DRIVERS.CUSTOM_PRICE_CANCEL' | translate }}
                </button>
                <button
                  (click)="applyCustomPrice()"
                  [disabled]="customPriceAmount === null || customPriceAmount < minAmount"
                  class="flex-1 py-2 rounded-xl border-2 border-primary bg-primary text-white hover:bg-primary-dark transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {{ 'DRIVERS.CUSTOM_PRICE_APPLY' | translate }}
                </button>
              </div>
            </div> -->
            </div>
        </div>  

        <!-- Drivers Cards -->
        <div *ngFor="let driver of (listDriversAccepted | slice:0:visibleDriversCount); let i = index"
          class="w-full bg-white rounded-2xl shadow-lg p-4 hover:shadow-xl transition-all">
          <div class="flex items-center gap-3 mb-3">
            <!-- Photo -->
            <div class="relative">
              <img *ngIf="driver.image" [src]="loadProfile(driver.image)" [alt]="driver.name"
                class="w-14 h-14 rounded-full object-cover border-2 border-primary-100" />
              <img *ngIf="!driver.image" src="icons/driver-icon.png"  alt="Default Image" class="w-14 h-14 rounded-full object-cover border-2 border-primary-100" />    
              <div
                class="absolute -bottom-1 -right-1 bg-primary text-white text-xs px-1.5 py-0.5 rounded-full flex items-center gap-0.5">
                <mat-icon class="text-xs">star</mat-icon>
                {{ driver.rating }}
              </div>
            </div>


            <!-- Details -->
            <div class="flex-1 min-w-0">
              <div class="flex items-center justify-between mb-1">
                <h3 class="text-gray-800 font-semibold truncate">{{ driver.name }}</h3>
                  <span class="text-black font-bold text-2xl ml-2">
                    {{ driver.fare + globalTip }} DH
                  </span>
              </div>
              <div class="flex items-center gap-2 mb-1">
                <span class="bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full">
                  {{ driver.taxiType == 2 ? ('SMALL_TAXI_1' | translate) : ('BIG_TAXI_1' | translate) }}
                </span>
                <span class="text-gray-400 text-xs">
                 taxi Num:  {{ driver.taxiNum }}
                </span>
              </div>
              <div class="flex items-center gap-3 text-xs text-gray-500">
                <span class="flex items-center gap-1 text-base">
                  <mat-icon class="text-primary text-base">location_on</mat-icon>
                  {{ formatDistance(driver.distance) }}
                </span>
                <span class="flex items-center gap-1 text-base">
                <mat-icon class="text-blue-600 text-base">schedule</mat-icon>
                {{ calculateDurationMinutes(driver.distance) | formatTime }} 
                 
              </span>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="flex items-center gap-2">
            <button (click)="handleRejectDriver(driver.offerId)" 


              class="hover:bg-gray-50 hover:border-gray-300 bg-white border-gray-200 flex-1 font-bold py-2 rounded-xl border-2 text-gray-600 text-xl transition-all active:scale-95">
              {{ 'DRIVERS.CUSTOM_PRICE_CANCEL' | translate }}
            </button>
            <button (click)="handleSelectDriver(driver)" 
              
              class=" hover:bg-primary-dark hover:border-primary-dark bg-primary border-primary flex-1 font-bold py-2 rounded-xl border-2 text-black text-xl transition-all active:scale-95">
              {{ 'DRIVERS.CUSTOM_PRICE_APPLY' | translate }}
            </button>
          </div>
      
      </div>
      </div>
    }@else {
      <div class="bg-red-50 border-2 border-red-100 rounded-2xl p-4 mb-4">
        <p class="text-red-600 text-center" *ngIf="isSearchCancelled()">
           {{ 'SEARCH.CANCELLED' | translate }}
        </p>
        <p class="text-red-600 text-center" *ngIf="errorMessage != ''">
           {{ errorMessage }}
        </p>
      </div>

    }

  </div>
  <div *ngIf="showLocationPicker" class="fixed inset-0 bg-white z-50 flex flex-col">
    <!-- Header -->
    <div class="pt-6 pb-6 px-4" style="background: linear-gradient(135deg, #F4BE00, #FFA500, #D4A000);">
      <div class="flex items-center justify-between">
        <h2 class="text-white">
          {{ showLocationPicker === 'pickup' ? ('LOCATION_PICKER.PICKUP' | translate) : ('LOCATION_PICKER.DESTINATION' | translate) }}
        </h2>
        <button (click)="closeLocationPicker()" class="text-white p-2 hover:bg-white/10 rounded-lg transition-colors">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Search Bar -->
      <div class="relative mt-4">
        <mat-icon class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-sm">search</mat-icon>
        <input type="text" [(ngModel)]="searchQuery" (input)="onSearchQueryChange(searchQuery)"
          [placeholder]="'COMMON.SEARCH' | translate"
          class="w-full pl-12 pr-4 py-3 border-2 border-white/20 bg-white/10 backdrop-blur-sm text-white placeholder-white/60 rounded-2xl focus:outline-none focus:border-white/40 focus:bg-white/20"
          autofocus />
      </div>
    </div>


  </div>

  <!-- Loading Overlay -->
  <div *ngIf="isProcessing" class="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center">
    <div class="bg-white rounded-3xl p-8 shadow-2xl text-center">
      <div class="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p class="text-gray-800 font-semibold mb-2">{{ 'PROCESSING.TITLE' | translate }}</p>
      <p class="text-gray-500 text-sm">{{ 'PROCESSING.MESSAGE' | translate }}</p>
    </div>
  </div>

  <!-- Floating Price Adjuster Footer -->
  <div *ngIf="showPriceAdjuster  && listDriversAccepted.length==0"
    [ngClass]="{
      'opacity-50 pointer-events-none': isSearching
    }"
    class="absolute bottom-0 left-0 right-0 bg-white border-t-4 border-primary shadow-2xl z-40 footer transition-all">
    <div class="max-w-lg mx-auto px-4 py-4">
      <p class="text-xs text-gray-600 mb-3 text-center">
        {{ 'PRICE_ADJUSTER.ADJUST_PRICE' | translate }}
      </p>

      <div class="flex items-center gap-3">
        <button 
          (click)="adjustPrice(-5)" 
          [disabled]="globalTip-5<=0 || isSearching"
          [ngClass]="{
            'opacity-50 cursor-not-allowed': globalTip-5<=0 || isSearching,
            'hover:bg-red-100': globalTip-5>0 && !isSearching
          }"
          class="flex-1 py-3 rounded-xl border-2 border-red-200 bg-red-50 text-black font-bold transition">
          -5 DH
        </button>

        <div class="flex-1 text-center bg-primary-50 py-3 rounded-xl border-2 border-primary-100">
          <p class="text-xs text-gray-600">{{ 'PRICE_ADJUSTER.ADJUSTED_PRICE' | translate }}</p>
          <div class="flex items-center justify-center gap-1">
             <span class="text-xl font-bold text-black font-bold " style="width: 100%;">+</span>
            <input
              type="number"
              [(ngModel)]="globalTip"
              style="border: none;width: 100%;"
              inputmode="numeric"
              class="no-spinner  px-2 py-0 border-2 border-primary-200 rounded text-center text-xl font-bold text-black font-bold focus:outline-none focus:border-primary text-black font-bold"
              (keydown)="onlyNumbers($event)"
              (paste)="blockPasteNonNumeric($event)"
              (keydown.enter)="applyGlobalPrice(globalTip)"
              (blur)="applyGlobalPrice(globalTip)"
              (change)="cd.markForCheck()"
            />

            <span class="text-xl font-bold text-black font-bold" style="width: 100%;">DH</span>
          </div>
        </div>

        <button (click)="adjustPrice(5)" [disabled]="isSearching"
          [ngClass]="{
            'opacity-50 cursor-not-allowed': isSearching,
            'hover:bg-primary-100': !isSearching
          }"
          class="flex-1 py-3 rounded-xl border-2 border-primary-100 bg-primary-50 text-black font-bold transition">
          +5 DH
        </button>
      </div>
    </div>
  </div>
</div>